// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CN2trtwQqgYiNl {
  position: relative;
  width: 50px;
  height: 32px;
  border: 2px transparent solid;
  border-radius: var(--ds-border-radius-100, 3px);
  list-style: none;
}
.U5jkWD4UCEra4y {
  border: 2px var(--ds-border-selected, #0c66e4) solid;
}
.U5jkWD4UCEra4y::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 2px var(--ds-border-inverse, #ffffff) solid;
  pointer-events: none;
}
.CN2trtwQqgYiNl:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .CN2trtwQqgYiNl:focus {
  outline-color: -webkit-focus-ring-color;
}
.CN2trtwQqgYiNl:focus .mac.firefox {
  outline-color: AccentColor;
}
.zzAcsDqvFnUJt7 {
  position: relative;
  width: 50px;
  height: 32px;
  background-color: var(--tile-background-color, var(--ds-skeleton, #091e420f));
  cursor: pointer;
}
.body-color-blind-mode-enabled .zzAcsDqvFnUJt7::before,
.body-color-blind-mode-enabled ~ div .zzAcsDqvFnUJt7::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
}
.zzAcsDqvFnUJt7:hover {
  background-color: var(--tile-background-color-hovered, var(--ds-skeleton, #091e420f));
}
/**
 * Defines tile color variables on a class for each tile color name.
 * Consumers of tiles outside of their components can import this LESS file,
 * which will load up CSS variables on any element with the corresponding class
 * name (e.g. \`.green\`).
 */
.DoCPXVyYFaKRmJ {
  --tile-background-color: var(--ds-background-accent-green-subtler, #baf3db);
  --tile-background-color-hovered: var(--ds-background-accent-green-subtler-hovered, #7ee2b8);
  --tile-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.RZ3Y2QdAWn2KI7 {
  --tile-background-color: var(--ds-background-accent-green-subtle, #4bce97);
  --tile-background-color-hovered: var(--ds-background-accent-green-subtle-hovered, #7ee2b8);
  --tile-text-color: var(--ds-text-accent-green-bolder, #164b35);
}
.x9JV7hByUVRRab {
  --tile-background-color: var(--ds-background-accent-green-bolder, #1f845a);
  --tile-background-color-hovered: var(--ds-background-accent-green-bolder-hovered, #216e4e);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.krO2VObnUH12pC {
  --tile-background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-subtler-hovered, #f5cd47);
  --tile-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.czGM_AQjb2aI1J {
  --tile-background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-subtle-hovered, #f5cd47);
  --tile-text-color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.S4huW8c54LBSW7 {
  --tile-background-color: var(--ds-background-accent-yellow-bolder, #946f00);
  --tile-background-color-hovered: var(--ds-background-accent-yellow-bolder-hovered, #7f5f01);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.eA2gXj4DsKxkaW {
  --tile-background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  --tile-background-color-hovered: var(--ds-background-accent-orange-subtler-hovered, #fec57b);
  --tile-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.j2US20xmgaueOp {
  --tile-background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  --tile-background-color-hovered: var(--ds-background-accent-orange-subtle-hovered, #fec57b);
  --tile-text-color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.Bo_6dliMnXJB2i {
  --tile-background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  --tile-background-color-hovered: var(--ds-background-accent-orange-bolder-hovered, #974f0c);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.FmdY3ToqS1X9tj {
  --tile-background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  --tile-background-color-hovered: var(--ds-background-accent-red-subtler-hovered, #ff9c8f);
  --tile-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
._FEjPZzmn87oIN {
  --tile-background-color: var(--ds-background-accent-red-subtle, #f87462);
  --tile-background-color-hovered: var(--ds-background-accent-red-subtle-hovered, #ff9c8f);
  --tile-text-color: var(--ds-text-accent-red-bolder, #601e16);
}
.DwTbMunHrXnGmo {
  --tile-background-color: var(--ds-background-accent-red-bolder, #ca3521);
  --tile-background-color-hovered: var(--ds-background-accent-red-bolder-hovered, #ae2a19);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.omVI6lpt9_OCGR {
  --tile-background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  --tile-background-color-hovered: var(--ds-background-accent-purple-subtler-hovered, #b8acf6);
  --tile-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.Y3FXjXlM6DFYXN {
  --tile-background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  --tile-background-color-hovered: var(--ds-background-accent-purple-subtle-hovered, #b8acf6);
  --tile-text-color: var(--ds-text-accent-purple-bolder, #352c63);
}
.rssO3kfwcyxU4I {
  --tile-background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  --tile-background-color-hovered: var(--ds-background-accent-purple-bolder-hovered, #5e4db2);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.gsgBc31EMoPkc9 {
  --tile-background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  --tile-background-color-hovered: var(--ds-background-accent-blue-subtler-hovered, #85b8ff);
  --tile-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.Cf6r1ITQq5Axsf {
  --tile-background-color: var(--ds-background-accent-blue-subtle, #579dff);
  --tile-background-color-hovered: var(--ds-background-accent-blue-subtle-hovered, #85b8ff);
  --tile-text-color: var(--ds-text-accent-blue-bolder, #09326c);
}
.pb5aJOrNt88tW8 {
  --tile-background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  --tile-background-color-hovered: var(--ds-background-accent-blue-bolder-hovered, #0055cc);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.Q5QXitbOVD5DqS {
  --tile-background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  --tile-background-color-hovered: var(--ds-background-accent-teal-subtler-hovered, #8bdbe5);
  --tile-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.rqEmSHqlR8w2Bz,
.OtvGcCGG3_tMhR {
  --tile-background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  --tile-background-color-hovered: var(--ds-background-accent-teal-subtle-hovered, #8bdbe5);
  --tile-text-color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.QeCYEGsxrGpfmi {
  --tile-background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  --tile-background-color-hovered: var(--ds-background-accent-teal-bolder-hovered, #206b74);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.THSWYeWQy5TmiM {
  --tile-background-color: var(--ds-background-accent-lime-subtler, #D3F1A7);
  --tile-background-color-hovered: var(--ds-background-accent-lime-subtler-hovered, #b3df72);
  --tile-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.WyIWvsb2HTjSij {
  --tile-background-color: var(--ds-background-accent-lime-subtle, #94c748);
  --tile-background-color-hovered: var(--ds-background-accent-lime-subtle-hovered, #b3df72);
  --tile-text-color: var(--ds-text-accent-lime-bolder, #37471f);
}
.IJTnZcW_5jMxNt {
  --tile-background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  --tile-background-color-hovered: var(--ds-background-accent-lime-bolder-hovered, #4c6b1f);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.P8M1pJDEEUlOeP {
  --tile-background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-subtler-hovered, #f797d2);
  --tile-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.TzGTn_fKwo6x40,
.f9hgpR8_OKbLxg {
  --tile-background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-subtle-hovered, #f797d2);
  --tile-text-color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.vHrOjpLpZTq2ok {
  --tile-background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  --tile-background-color-hovered: var(--ds-background-accent-magenta-bolder-hovered, #943d73);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
.vNdXiEG7tQ5bWc {
  --tile-background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  --tile-background-color-hovered: var(--ds-background-accent-gray-subtler-hovered, #b3b9c4);
  --tile-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.OkKRdueoWv5iVj,
.vJLOa08deP25d2 {
  --tile-background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  --tile-background-color-hovered: var(--ds-background-accent-gray-subtle-hovered, #b3b9c4);
  --tile-text-color: var(--ds-text-accent-gray-bolder, #091e42);
}
.TI8tETqp34f1sf {
  --tile-background-color: var(--ds-background-accent-gray-bolder, #626f86);
  --tile-background-color-hovered: var(--ds-background-accent-gray-bolder-hovered, #44546f);
  --tile-text-color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
export var tileContainer = `CN2trtwQqgYiNl`;
var _1 = `U5jkWD4UCEra4y`;
export { _1 as "tileContainer--selected" };
export var tile = `zzAcsDqvFnUJt7`;
export var green_light = `DoCPXVyYFaKRmJ`;
export var green = `RZ3Y2QdAWn2KI7`;
export var green_dark = `x9JV7hByUVRRab`;
export var yellow_light = `krO2VObnUH12pC`;
export var yellow = `czGM_AQjb2aI1J`;
export var yellow_dark = `S4huW8c54LBSW7`;
export var orange_light = `eA2gXj4DsKxkaW`;
export var orange = `j2US20xmgaueOp`;
export var orange_dark = `Bo_6dliMnXJB2i`;
export var red_light = `FmdY3ToqS1X9tj`;
export var red = `_FEjPZzmn87oIN`;
export var red_dark = `DwTbMunHrXnGmo`;
export var purple_light = `omVI6lpt9_OCGR`;
export var purple = `Y3FXjXlM6DFYXN`;
export var purple_dark = `rssO3kfwcyxU4I`;
export var blue_light = `gsgBc31EMoPkc9`;
export var blue = `Cf6r1ITQq5Axsf`;
export var blue_dark = `pb5aJOrNt88tW8`;
export var sky_light = `Q5QXitbOVD5DqS`;
export var sky = `rqEmSHqlR8w2Bz`;
export var teal = `OtvGcCGG3_tMhR`;
export var sky_dark = `QeCYEGsxrGpfmi`;
export var lime_light = `THSWYeWQy5TmiM`;
export var lime = `WyIWvsb2HTjSij`;
export var lime_dark = `IJTnZcW_5jMxNt`;
export var pink_light = `P8M1pJDEEUlOeP`;
export var pink = `TzGTn_fKwo6x40`;
export var magenta = `f9hgpR8_OKbLxg`;
export var pink_dark = `vHrOjpLpZTq2ok`;
export var black_light = `vNdXiEG7tQ5bWc`;
export var black = `OkKRdueoWv5iVj`;
export var gray = `vJLOa08deP25d2`;
export var black_dark = `TI8tETqp34f1sf`;
export default ___CSS_LOADER_EXPORT___;
